import React, {memo} from 'react'
import {withErrorHandling} from '../../hoc'
import {RemovalConfirmationModal} from '../shared'
import {removePaymentMethod} from '../../backend'

const _RemovePaymentMethod = (
  {
    subscription,
    removePaymentMethod,
    onClose
  }
) => {

  const onRemovalConfirmed = async () => {
    const updated = await removePaymentMethod(subscription.paymentMethod.id)
    onClose(updated)
  }

  return (
    <RemovalConfirmationModal
      confirmingRemovalOf='payment method'
      onRemovalApproved={onRemovalConfirmed}
      onRemovalCancelled={() => onClose()}/>
  )
}

let RemovePaymentMethod = (props) => {
  const {handleError} = props
  if (!props.subscription.paymentMethod) {
    props.navigate('/c/account/billing')
    return null
  }
  props = {...props, removePaymentMethod: handleError(removePaymentMethod)}
  return (<_RemovePaymentMethod {...props}/>)
}


RemovePaymentMethod = withErrorHandling(RemovePaymentMethod)
RemovePaymentMethod = memo(RemovePaymentMethod)

export {_RemovePaymentMethod, RemovePaymentMethod}

export default RemovePaymentMethod